/**
 * The two answers the website's sponsor form offers, spelled out. Kept in step
 * with REGION_LABELS in the API's sponsor-controller, which is what the
 * notification emails use.
 */
export const REGION_LABELS = {
  NIGERIA: "Nigeria",
  OTHER: "Another region",
};

export const REGION_DESCRIPTIONS = {
  NIGERIA: "A mapped community in Nigeria",
  OTHER: "Another region or country (to be scoped)",
};
